let addresses = [
  { value: 0x00, device: "None" },
  { value: 0x10, device: "INVERTER" },
  { value: 0x30, device: "MPPT1" },
  { value: 0x31, device: "MPPT2" },
  { value: 0x32, device: "MPPT3" },
  { value: 0x33, device: "MPPT4" },
  { value: 0x34, device: "MPPT5" },
  { value: 0x35, device: "MPPT6" },
  { value: 0x36, device: "MPPT7" },
  { value: 0x37, device: "MPPT8" },
  { value: 0x38, device: "MPPT9" },
  { value: 0x39, device: "MPPT10" },
  { value: 0x3a, device: "MPPT11" },
  { value: 0x3b, device: "MPPT12" },
  { value: 0x3c, device: "MPPT13" },
  { value: 0x3d, device: "MPPT14" },
  { value: 0x3e, device: "MPPT15" },
  { value: 0x3f, device: "MPPT16" },
  { value: 0x50, device: "BCU" },
  { value: 0x99, device: "DCCONN" },
  { value: 0x51, device: "BMS_OFFSET" },
  { value: 0x60, device: "DBMS" },
  { value: 0x61, device: "DAB1" },
  { value: 0x62, device: "DAB2" },
  { value: 0x63, device: "DAB3" },
  { value: 0x64, device: "DAB4" },
];

export function getDeviceName(value) {
  for (let index = 0; index < addresses.length; index++) {
    if (addresses[index].value == value) {
      return addresses[index].device;
    }
  }

  return addresses[0].device;
}
